import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

const BRAKEACE_STATE_KEY = 'brakeace_oauth_state';

// HTTP endpoint (avoids CORS issues with callable)
const BRAKEACE_EXCHANGE_URL = 'https://us-central1-victorise-video-tool.cloudfunctions.net/brakeaceExchangeToken';

/**
 * Handles OAuth callback from BrakeAce.
 * Redirect URI: /oauth/callback (must be in BrakeAce PORTAL_OAUTH_REDIRECT_URIS)
 */
const OAuthCallback = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [status, setStatus] = useState('Processing...');

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');

      if (error) {
        setStatus(`Authorization failed: ${error}`);
        window.history.replaceState({}, document.title, '/oauth/callback');
        setTimeout(() => navigate('/profile'), 2000);
        return;
      }

      if (!code || !state) {
        setStatus('Invalid callback - missing code or state');
        setTimeout(() => navigate('/profile'), 2000);
        return;
      }

      const storedState = sessionStorage.getItem(BRAKEACE_STATE_KEY);
      sessionStorage.removeItem(BRAKEACE_STATE_KEY);
      if (state !== storedState) {
        setStatus('Invalid state - possible CSRF');
        setTimeout(() => navigate('/profile'), 2000);
        return;
      }

      const currentUser = user || auth.currentUser;
      if (!currentUser) {
        setStatus('Please log in first');
        setTimeout(() => navigate('/login'), 2000);
        return;
      }

      try {
        const redirectUri = `${window.location.origin}/oauth/callback`;
        const idToken = await currentUser.getIdToken();
        const response = await fetch(BRAKEACE_EXCHANGE_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify({ code, redirect_uri: redirectUri }),
        });
        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.error || `HTTP ${response.status}`);
        }
        setStatus('BrakeAce connected successfully!');
        window.history.replaceState({}, document.title, '/oauth/callback');
        setTimeout(() => navigate('/profile'), 1500);
      } catch (err) {
        console.error('BrakeAce OAuth error:', err);
        setStatus('Failed to connect BrakeAce: ' + (err?.message || err));
        setTimeout(() => navigate('/profile'), 3000);
      }
    };

    handleCallback();
  }, [user, navigate]);

  return (
    <div style={{ padding: 40, textAlign: 'center', color: '#e0e0e0' }}>
      <p>{status}</p>
      <p style={{ fontSize: 14, color: '#888' }}>Redirecting...</p>
    </div>
  );
};

export default OAuthCallback;
export { BRAKEACE_STATE_KEY };
